import React, { useContext } from 'react'
import './styles.scss'
const f = new Intl.NumberFormat('de-CH')
import LocalesContext from 'components/_locales/localeContext'

interface Props {
  data: [womenMenDataElement[], womenMenDataElement[]]
  title?: string
  sub?: string
  formatName?: (a: womenMenDataElement) => string
}
export const NameTable = ({
  data,
  title,
  sub,
  formatName = d => d[0]
}: Props) => {
  const __l: localesInterface = useContext<localesInterface>(LocalesContext)

  return (
    <div className='NameTableWrapper'>
      <div className='NameTable'>
        {(title || sub) && (
          <div className='ui text container titleholder'>
            {title && <div className='title'>{title}</div>}
            {sub && <div className='sub'>{sub}</div>}
          </div>
        )}
        <div className='ui text container'>
          <div className='wrapper women'>
          <div className='entry title'><div className='rank'/>Frauen</div>
            <div className='entry key'>
              <div className='rank'>{__l.nametable.keys[0]}</div>
              <div className='data'>{__l.nametable.keys[1]}</div>
              <div className='count'>{__l.nametable.keys[2]}</div>
            </div>
            {data[0].length > 0 &&
              data[0].map((m, i) => {
                return (
                  <>
                    {m[1] && (
                      <div className='entry'>
                        <div className='rank'>{m[2]}</div>
                        <div className='data'>{formatName(m)}</div>
                        <div className='count'>
                          {+m[1] > 9999 ? f.format(+m[1]) : m[1]}
                        </div>
                      </div>
                    )}
                  </>
                )
              })}
          </div>
          <div className='wrapper men'>
          <div className='entry title'><div className='rank'/>Männer</div>

            <div className='entry key'>
              <div className='rank'>{__l.nametable.keys[0]}</div>
              <div className='data'>{__l.nametable.keys[1]}</div>
              <div className='count'>{__l.nametable.keys[2]}</div>
            </div>
            {data[1].length > 0 &&
              data[1].map(m => {
                return (
                  <>
                    {m[0] && (
                      <div className='entry'>
                        <div className='rank'>{m[2]}</div>
                        <div className='data'>{formatName(m)}</div>
                        <div className='count'>
                          {+m[1] > 9999 ? f.format(+m[1]) : m[1]}
                        </div>
                      </div>
                    )}
                  </>
                )
              })}
          </div>
        </div>
      </div>{' '}
      <div className='bottomhide' />
    </div>
  )
}
